import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import {UserPrivilegeService} from '../../../../services/common/user-privilege/user-privilege.service';
import {LicenseApiService} from '../../../../services/api/settings/administration/license/license-api.service';

@AcDialog({
  width: 550,
})
@Component({
  selector: 'server-dialog',
  templateUrl: './server-dialog.component.html',
  styleUrls: ['./server-dialog.component.scss']
})
export class ServerDialogComponent implements OnInit , AfterViewInit{

  data;
  @ViewChild('mapForm') mapForm: NgForm;
  conf;
  showMemoryLimitationNotice = false;
  canSubmit: boolean;
  readonly MIN_USERS_FOR_LIMITATION = 1000000;
  protocolList = [ {text: 'HTTP', value: 80}, {text: 'HTTPS', value: 443}];
  routerCredentialsOptions: any;
  complementaryParameters: any;
  initialUseGeneralCredentials: any;
  routerUsersOptions: any;
  isEditMode: boolean;
  dialogTitle: string;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig,
              private userPrivilege: UserPrivilegeService,
              private licenseApiService: LicenseApiService) {
    this.data = dialogConfig.dialogData[0];
    this.complementaryParameters = dialogConfig.dialogData[1];
    this.conf = dialogConfig;
  }

  ngOnInit(): void {
    this.canSubmit = this.userPrivilege.isAuthorized();
    this.licenseApiService.getLicense().subscribe((license) => {
      this.showMemoryLimitationNotice = this.isRouterMemoryLimitationIsApply(license);
    });
    this.initialUseGeneralCredentials = this.data.useGeneralCredentials;
    this.routerUsersOptions = this.complementaryParameters.routerUsers;
    this.routerCredentialsOptions = this.complementaryParameters.routerCredentials;
    this.selectDefaultOperatorId(this.data, this.complementaryParameters.routerUsers);
    this.selectDefaultCredentialsId(this.data, this.complementaryParameters.routerCredentials);
    this.isEditMode = this.complementaryParameters.isEdit;
    this.dialogTitle = this.complementaryParameters.isEdit ? 'Edit Server' : 'Add Server';

  }

  ngAfterViewInit(): void {
    this.mapForm.form.statusChanges.subscribe(() => {
      this.conf.submitButtonDisabled = !this.mapForm.form.valid;
    });

  }

  private isRouterMemoryLimitationIsApply(license: any): any {
    if (license && license.features) {
      const numberOfUsers = license.features.find(feature => feature.feature === 'numberOfUsers');

      return numberOfUsers && parseInt(numberOfUsers.value, 10) > this.MIN_USERS_FOR_LIMITATION;
    }

    return false;
  }

  selectDefaultOperatorId(routingServer, routerUsers): any {
    if (routingServer.operatorId && routingServer.operatorId !== -1) {
      this.data.operator = routingServer.operatorId;
    } else {
      this.data.operator = routerUsers[0].id;
    }
  }

  selectDefaultCredentialsId(routingServer, routerCredentials): any {
    if (routingServer.credentialsId && routingServer.credentialsId !== -1) {
      this.data.credentials = routingServer.credentialsId;
    } else {
      this.data.credentials = routerCredentials[0].id;
    }
  }

  updateProtocol(port): void {
    this.data.protocol = port.value === 80 ? 'http' : 'https';
  }
}
